import { render, staticRenderFns } from "./FamilyPage.vue?vue&type=template&id=08229bc2&scoped=true&"
import script from "./FamilyPage.vue?vue&type=script&lang=js&"
export * from "./FamilyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08229bc2",
  null
  
)

export default component.exports